// src/components/Admin/PrivateRoute.js 
import React from 'react';
import { auth } from '../../firebase';
import { onAuthStateChanged } from 'firebase/auth';
import AdminLogin from './AdminLogin'; // 管理者ログインコンポーネントをインポート

const PrivateRoute = ({ children }) => {
  const [user, setUser] = React.useState(null);
  const [loading, setLoading] = React.useState(true);

  React.useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      if (currentUser && currentUser.emailVerified) {
        setUser(currentUser);
      } else {
        setUser(null);
      }
      setLoading(false);
    });
    return () => unsubscribe();
  }, []);

  if (loading) {
    return <div>読み込み中...</div>;
  }

  return user ? children : <AdminLogin />;
};

export default PrivateRoute;
